import React, { memo } from "react";
import { FaPlus, FaArrowLeft } from "react-icons/fa";
import "./SignedAssignedItemsPanel.css";

const SignedAssignedItemsPanel = ({
  filteredAssignedItems,
  assignedItemsFilter,
  onAssignedItemsFilterChange,
  filterInputRef,
  shouldMaintainFilterFocusRef,
  editingQuantities,
  activeInputRef,
  onReturnQuantityChange,
  onDebouncedEditQuantity,
  onAddReturnItem,
  onOpenAddItemModal,
}) => {
  return (
    <div className="assigned-items-section">
      <div className="assigned-items-header">
        <h4>פריטים חתומים</h4>
        <input
          ref={filterInputRef}
          type="text"
          className="assigned-items-filter"
          placeholder="סנן לפי שם פריט או מספר סידורי..."
          value={assignedItemsFilter}
          onChange={(e) => onAssignedItemsFilterChange(e.target.value)}
          onFocus={() => {
            shouldMaintainFilterFocusRef.current = true;
          }}
          onBlur={() => {
            shouldMaintainFilterFocusRef.current = false;
          }}
        />
      </div>
      <div className="assigned-items-table">
        <table>
          <thead>
            <tr>
              <th>שם הפריט</th>
              <th>מספר סידורי</th>
              <th>כמות מוקצית</th>
              <th>תאריך חתימה</th>
              <th>סטטוס</th>
              <th>פעולות</th>
            </tr>
          </thead>
          <tbody>
            {filteredAssignedItems.map((item) => (
              <tr key={item.id}>
                <td>
                  <div className="item-name-container">
                    <span className="item-name">{item.itemName}</span>
                    {item.isOrganic !== null && (
                      <span
                        className={`organic-badge ${
                          item.isOrganic ? "organic" : "synthetic"
                        }`}
                      >
                        {item.isOrganic ? "אורגני" : "קווי"}
                      </span>
                    )}
                  </div>
                </td>
                <td>{item.serialNumber || "-"}</td>
                <td>
                  <div className="assigned-quantity-display">
                    <span className="quantity-value">
                      {item.isSerialItem && Math.abs(item.assignedQuantity)}
                    </span>
                  </div>
                  {!item.isSerialItem && (
                    <div className="quantity-editor">
                      <input
                        type="number"
                        min="0"
                        max={
                          !item.isSerialItem &&
                          item.availableQuantity !== undefined
                            ? Math.abs(item.assignedQuantity) +
                              item.availableQuantity
                            : Math.abs(item.assignedQuantity)
                        }
                        id={`quantity-${item.id}`}
                        name={`quantity-${item.id}`}
                        value={
                          editingQuantities[item.id] !== undefined
                            ? editingQuantities[item.id]
                            : Math.abs(item.assignedQuantity)
                        }
                        onChange={(e) => {
                          const input = e.target;
                          let newQuantity =
                            input.value === ""
                              ? Math.abs(item.assignedQuantity)
                              : parseInt(input.value, 10) || 0;

                          const maxQuantity =
                            !item.isSerialItem &&
                            item.availableQuantity !== undefined
                              ? Math.abs(item.assignedQuantity) +
                                item.availableQuantity
                              : Math.abs(item.assignedQuantity);

                          if (newQuantity > maxQuantity) {
                            newQuantity = maxQuantity;
                            input.value = maxQuantity;
                            if (
                              !item.isSerialItem &&
                              item.availableQuantity !== undefined
                            ) {
                              alert(
                                `הכמות המקסימלית היא ${maxQuantity} (${Math.abs(
                                  item.assignedQuantity,
                                )} מוקצית + ${
                                  item.availableQuantity
                                } זמין)`,
                              );
                            } else {
                              alert(
                                `הכמות המקסימלית היא ${maxQuantity}`,
                              );
                            }
                          }

                          if (newQuantity < 0) {
                            newQuantity = 0;
                            input.value = 0;
                          }

                          if (document.activeElement === input) {
                            activeInputRef.current = {
                              id: item.id,
                              position: input.selectionStart,
                            };
                          }

                          onReturnQuantityChange(item.id, newQuantity);
                          onDebouncedEditQuantity(item, newQuantity);
                        }}
                        onFocus={(e) => {
                          const wasRestoring =
                            activeInputRef.current?.id === item.id;
                          if (!wasRestoring) {
                            e.target.select();
                          }
                          activeInputRef.current = {
                            id: item.id,
                            position: null,
                          };
                        }}
                        onBlur={() => {
                          if (activeInputRef.current?.id === item.id) {
                            activeInputRef.current = {
                              id: null,
                              position: null,
                            };
                          }
                        }}
                        className="quantity-input"
                      />
                    </div>
                  )}
                </td>
                <td>
                  {item.assignedAt
                    ? new Date(
                        item.assignedAt.seconds * 1000,
                      ).toLocaleDateString("he-IL")
                    : "-"}
                </td>
                <td>
                  <span className={`status-badge ${item.status}`}>
                    {item.status === "assigned"
                      ? "מוחתם"
                      : item.status === "available"
                        ? "זמין"
                        : item.status === "returned"
                          ? "זוכה"
                          : item.status}
                  </span>
                </td>
                <td>
                  <button
                    type="button"
                    className="return-btn"
                    onClick={() => onAddReturnItem(item)}
                    title="זיכוי"
                  >
                    <FaArrowLeft />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="assigned-items-footer">
        <button
          type="button"
          className="add-item-btn"
          onClick={onOpenAddItemModal}
        >
          <FaPlus />
          הוסף פריט
        </button>
      </div>
    </div>
  );
};

export default memo(SignedAssignedItemsPanel);
